import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const DashboardHeader = ({ total, onLock }) => (
  <motion.header
    initial={{ opacity: 0, y: -8 }}
    animate={{ opacity: 1, y: 0 }}
    className="flex items-start justify-between gap-5 mb-9"
  >
    <div>
      <div className="flex items-center gap-2 mb-3">
        <span className="service-indicator" />
        <span className="service-count">{total} services available</span>
      </div>
      <h1 className="dashboard-title">
        Your tools, <span>all in one place.</span>
      </h1>
      <p className="dashboard-subtitle">
        Search by what you need to do—not just by the name of the platform.
      </p>
    </div>

    <button type="button" onClick={onLock} className="mobile-lock">
      <SafeIcon name="Lock" />
      Lock
    </button>
  </motion.header>
);

export default DashboardHeader;